module.exports = __webpack_public_path__ + "img/banners.f02b4e83.svg";